import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { FormattedNumber } from '../misc'
import { getProperty, jobStatus, DATE_FORMAT } from '../utils'

function invoiceStatus(status) {
    switch (status) {
        case jobStatus.PENDING:
            return <span className="label">Upcoming job</span>
        case jobStatus.FINISHED:
            return <span className="label">Job Finished</span>
        case jobStatus.OVERTIME_REQUESTED:
            return <span className="label">Job Finished, Overtime Requested</span>
        case jobStatus.INVOICED:
            return <span className="label">Invoice Submitted</span>
        case jobStatus.REJECTED:
            return <span className="label label--danger">Invoice Rejected</span>
        case jobStatus.RESUBMITTED:
            return <span className="label">Invoice Resubmitted</span>
        case jobStatus.APPROVED:
            return <span className="label label--success">Approved</span>
        case jobStatus.PAID:
            return <span className="label label--primary">Paid</span>
    }

    return ''
}

class JobsList extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        jobs: PropTypes.arrayOf(PropTypes.shape({
            job_date: PropTypes.object.isRequired,
            job_number: PropTypes.string.isRequired,
            job_status: PropTypes.oneOf(Object.values(jobStatus)).isRequired,
            labour: PropTypes.number.isRequired,
            overtime: PropTypes.number.isRequired,
            owned_gear: PropTypes.number.isRequired,
            pay_date: PropTypes.object.isRequired,
            reimbursement: PropTypes.number.isRequired,
            uuid: PropTypes.string.isRequired,
        })).isRequired,
        modalActions: PropTypes.shape({
            showModal: PropTypes.func.isRequired,
        }).isRequired,
    }

    sum(...fields) {
        return this.props.jobs.reduce((acc, item) => (
            acc + fields.reduce((acc, field) => acc + item[field], 0)
        ), 0)
    }

    render() {
        const rows = this.props.jobs.map((item, index) => {
            let invoice = 'Not ready for invoicing'

            switch (item.job_status) {
                case jobStatus.PENDING:
                    break
                case jobStatus.OVERTIME_REQUESTED:
                    invoice = 'Overtime request pending'
                    break
                case jobStatus.FINISHED:
                    invoice = (
                        <div>
                            <Link className="btn btn--small btn--create" to={ `/job/${ item.uuid }/invoice` }>
                                Click here to invoice
                            </Link>
                        </div>
                    )
                    break
                case jobStatus.REJECTED:
                    invoice = (
                        <div>
                            <Link className="btn btn--small btn--change" to={ `/job/${ item.uuid }/invoice` }>
                                Click here to re-submit
                            </Link>
                        </div>
                    )
                    break
                case jobStatus.INVOICED:
                case jobStatus.RESUBMITTED:
                case jobStatus.APPROVED:
                case jobStatus.PAID:
                    invoice = (
                        <Link className="btn btn--small btn--primary" to={ `/job/${ item.uuid }/invoice` }>
                            View invoice
                        </Link>
                    )
                    break
            }

            return (
                <tr className="table-row" key={ index }>
                    <td className="table-cell" style={{ whiteSpace: 'nowrap' }}>{ item.job_number }</td>
                    <td className="table-cell">{ item.job_date.format(DATE_FORMAT) }</td>
                    <td className="table-cell">{ getProperty(item, 'client_obj.name', 'N/A') }</td>
                    <td className="table-cell">
                        <FormattedNumber currency="USD" style="currency" value={ item.labour } />
                    </td>
                    <td className="table-cell">
                        <FormattedNumber currency="USD" style="currency" value={ item.owned_gear } />
                    </td>
                    <td className="table-cell">
                        <FormattedNumber currency="USD" style="currency" value={ item.reimbursement } />
                    </td>
                    <td className="table-cell">
                        { item.overtime ? (
                            <FormattedNumber currency="USD" style="currency" value={ item.overtime } />
                        ) : 'None'}
                    </td>
                    <td className="table-cell">
                        <FormattedNumber
                            currency="USD"
                            style="currency"
                            value={ item.labour + item.owned_gear + item.reimbursement + item.overtime }
                        />
                    </td>
                    <td className="table-cell">{ invoice }</td>
                    <td className="table-cell">{ invoiceStatus(item.job_status) }</td>
                    <td className="table-cell">{ item.pay_date.format(DATE_FORMAT) }</td>
                </tr>
            )
        })

        const totalsRow = (this.props.jobs.length > 0) && (
            <tr className="table-row--accent">
                <th className="table-head-cell text-right" colSpan={ 3 }>Grand totals:</th>
                <th className="table-head-cell">
                    <FormattedNumber currency="USD" style="currency" value={ this.sum('labour') } />
                </th>
                <th className="table-head-cell">
                    <FormattedNumber currency="USD" style="currency" value={ this.sum('owned_gear') } />
                </th>
                <th className="table-head-cell">
                    <FormattedNumber currency="USD" style="currency" value={ this.sum('reimbursement') } />
                </th>
                <th className="table-head-cell">
                    <FormattedNumber currency="USD" style="currency" value={ this.sum('overtime') } />
                </th>
                <th className="table-head-cell">
                    <FormattedNumber
                        currency="USD"
                        style="currency"
                        value={ this.sum('labour', 'owned_gear', 'reimbursement', 'overtime') }
                    />
                </th>
                <th className="table-head-cell" colSpan={ 3 } />
            </tr>
        )

        return (
            <table className="table">
                { totalsRow && (
                    <thead>
                        { totalsRow }
                    </thead>
                ) }
                <thead>
                    <tr className="table-row">
                        <th className="table-head-cell">Job</th>
                        <th className="table-head-cell">Date</th>
                        <th className="table-head-cell">Client</th>
                        <th className="table-head-cell">Labor</th>
                        <th className="table-head-cell">Gear</th>
                        <th className="table-head-cell">Reimbursements</th>
                        <th className="table-head-cell">Overtime</th>
                        <th className="table-head-cell">Total Payment</th>
                        <th className="table-head-cell">Invoice</th>
                        <th className="table-head-cell">Invoice Status</th>
                        <th className="table-head-cell">Pay Date</th>
                    </tr>
                </thead>
                <tbody>
                    { rows }
                </tbody>
            </table>
        )
    }
}

export default JobsList



// WEBPACK FOOTER //
// ./app/components/jobs/jobs_list.js